import { IoTicket } from "react-icons/io5";
import { Link, animateScroll as scroll } from "react-scroll";

function HeaderInternal() {
    return (
        <>
            <header className="py-3 bg-[#2b3d87]">
                <div className="container px-3 mx-auto flex justify-between items-center">
                   
                    <nav>
                        <ul className="flex gap-4 text-white">
                            <li><a href="/">Головна</a></li>
                        </ul>
                    </nav>
                </div>

            </header>
        </>
    )
}

export default HeaderInternal;